import DynamicComponentWrapper from './dynamic-component-wrapper';

export default DynamicComponentWrapper;
